import { render, staticRenderFns } from "./OVZ.vue?vue&type=template&id=8ea855ba&scoped=true&"
import script from "./OVZ.vue?vue&type=script&lang=js&"
export * from "./OVZ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea855ba",
  null
  
)

export default component.exports